<template>
  <gj-modal
      notFooterPadding
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增关键词</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :targetingType="0"
            @campaignChange="setSuggestedBidList"
        ></app-base-info>
        <app-keyword-picker
            ref="picker"
            :form="form.keywordPickerForm"
            title="关键词"
            :params="params"
            :marketId="marketId"
            :currencySymbol="adStore.SB.currencySymbol"
            :matchTypeOption="AdKeywordEnum.SB.matchTypeOptionNew"
            :bid="adStore.SB.defaultBid"
        ></app-keyword-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import AppBaseInfo from "../common/sb-base-info";
import AppKeywordPicker from "../common/keyword-picker";
import { adStore } from "@/views/modules/ad/common/store";
import {isMeaningfulMixin, modalMixIn} from "@/minxins";
import {AdGroupEnum, AdKeywordEnum} from "@/views/modules/ad/common/enum";
import { addSpAdKeyword, createAdsSbKeywords } from "@/api/ad";

export default {
  name: "app-add-sp-ad-keyword",
  mixins: [modalMixIn, isMeaningfulMixin],
  components: {AppKeywordPicker, AppBaseInfo},
  props: {
    // 站点id
    marketId: {
      required: true
    },
  },
  provide() {
    return {}
  },
  data() {
    return {
      adStore,
      params: {
        campaignId: null
      },
      form: {
        baseInfoForm: {
          campaignTargetType: AdGroupEnum.SP.targetingType.KEYWORD,
          campaignId: null,
          groupId: null,
        },
        keywordPickerForm: {
          items: [],
          matchType: AdKeywordEnum.SP.matchType.EXACT,
          matchTypes: [
            AdKeywordEnum.SP.matchType.EXACT,
            AdKeywordEnum.SP.matchType.PHASE,
            AdKeywordEnum.SP.matchType.BROAD
          ],
          bid: null,
        }
      },
      campaignId: null,
      AdKeywordEnum: AdKeywordEnum,
      adSuggestKeyword$: null,
      suggestedBidList: [], // 关键词
    }
  },
  methods: {
    // 广告活动切换事件
    async setSuggestedBidList(campaignId) {
      this.params.campaignId = campaignId
      this.$refs.picker.suggestedBid(this.params)
    },
    confirm() {
      const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
      if (formValid) {
        this.confirmLoading = true;
        const params = {
          marketId: this.marketId,
          keywords: this.form.keywordPickerForm.items.map(e => ({
            campaignId: this.form.baseInfoForm.campaignId,
            groupId: this.form.baseInfoForm.groupId,
            keywordText: e.keywordText,
            bid: e.bid,
            matchType: e.matchType,
          }))
        };
        createAdsSbKeywords(params)
          .then(() => {
            this.$gjDestroy();
            this.$emit('created');
          })
          .complete(() => this.confirmLoading = false);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.adStore.SB.campaign && this.adStore.SB.campaign.campaignId && this.setSuggestedBidList(this.adStore.SB.campaign.campaignId)
      }, 100);
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../common/common";
</style>
